import styled from 'styled-components';
import BaseDatePicker from '@/trio-ui/DatePicker';

export const DatePicker = styled(BaseDatePicker)`
  position: absolute;
  top: 38px;
  left: 0;
`;
